// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--alert-yellow:#ffde32;--alert-yellow-soft:#fff1ad;--error-red:#ff4a7a;--error-red-soft:#ffd5d5;--till-deep-blue:#0a9cd6;--till-dark-blue:#38a7ff;--till-blue:#1eb5f0;--till-green:#3de6a3;--till-green-soft:#93f1cb;--till-purple:#c99bf3;--dark-grey:#6f6f6f;--blue-grey:#e9eff3;--normal-grey:#a0a0a0;--light-grey:#f8f8f8}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
